export default "__VITE_ASSET__BA8_U53C__"